import { Grid } from "@mui/material";
import BatteryDistributionCard from "./BatteryDistributionCard";
import { FC } from "react";
import { BatteryDistribution } from "@/components/VirtualBattery/types/percentages";

interface BatteryDistributionAfterParams {
  batteryDistribution: BatteryDistribution;
}

export const BatteryDistributionAfter: FC<BatteryDistributionAfterParams> = ({ batteryDistribution }) => {
  return (
    <Grid container style={{ position: "relative" }}>
      <BatteryDistributionCard batteryDistribution={batteryDistribution} />
    </Grid>
  );
};

export default BatteryDistributionAfter;
